import { CheckoutProvider } from '@stripe/react-stripe-js/checkout';
import { loadStripe } from '@stripe/stripe-js';
import { inject } from 'mobx-react';
import React from 'react';
import { IModalContext, ModalChildComponentContextKey } from '../../../../../../../../models';
import { useClientStripeSessionByToken } from '../../../../../../../../queries';
import { IEventSurveyResponse, ILineItem } from '../../../../../../../models/Api';
import { StripeCheckoutForm } from './StripeCheckoutForm';

interface IProps extends IModalContext {
	stripePublicId: string;
	surveyResponse: IEventSurveyResponse;
	onRequestClose: (sessionId: string) => void;
	token: string;
	ticketsOrder: number;
	lineItems?: ILineItem[];
	pooledResponseBody?: IEventSurveyResponse;
}

export const CheckoutFormProviderWrap = ({
	stripePublicId,
	surveyResponse,
	onRequestClose,
	parentModal,
	token,
	ticketsOrder,
	lineItems,
	pooledResponseBody,
}: IProps) => {
	const stripeSession = useClientStripeSessionByToken();
	const stripePromise = React.useRef(() => {
		if (stripePublicId) {
			const sp = loadStripe(stripePublicId);
			return sp;
		}
		return null;
	}).current();

	const clientSecretPromise = React.useMemo(() => {
		return stripeSession.mutateAsync({
			token,
			quantity: ticketsOrder,
			// Send pooledResponseBody as 'response' so backend can map it to ResourceToProcessUponSuccessPayment
			response: pooledResponseBody || surveyResponse,
			items: lineItems,
			_type: 'EventRegistrationCheckout',
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<CheckoutProvider
			stripe={stripePromise}
			options={{
				clientSecret: clientSecretPromise,
			}}
		>
			<StripeCheckoutForm
				onSuccessClose={onRequestClose}
				onCloseModal={parentModal.onRequestClose}
				attendeeEmail={surveyResponse?.attendee?.email}
			/>
		</CheckoutProvider>
	);
};

export const CheckoutForm = inject(ModalChildComponentContextKey)(CheckoutFormProviderWrap);
